/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import { feathers } from '@/feathers-client';
import { HIDE_ERROR_AFTER_MS } from '@/Core/utilities';

const initialState = {
  customFields: [],
  isLoading: false,
  error: null,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    resetCustomFields(state) {
      state.customFields = [];
    },
    setError(state, error) {
      state.error = error;
    },
    hideError(state) {
      state.error = null;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setCustomFieldsData(state, customFields) {
      const mappedCustomFields = customFields.map(customField => {
        // Regex used by V1 cron
        const customFieldLabel = customField.name
          .replace(/[\s_]/gi, '-')
          .replace(/[^\w-]/gi, '')
          .replace(/-{2,}/gi, '-');
        return {
          value: `{{customfield_${customField.id}_${customFieldLabel}}}`,
          text: customField.name,
        };
      });
      state.customFields = state.customFields.concat(mappedCustomFields);
    },
  },
  actions: {
    async findCustomFields({ commit }) {
      commit('resetCustomFields');

      try {
        commit('setIsLoading', true);
        const response = await feathers.service('custom-fields').find({
          query: { $paginate: 'false' },
        });

        commit('setCustomFieldsData', response.data);
      } catch (error) {
        commit('setError', {
          service: 'Custom Fields',
          message: error.message,
        });
        setTimeout(() => {
          commit('hideError');
        }, HIDE_ERROR_AFTER_MS);
      }

      commit('setIsLoading', false);
    },
  },
};
